import { Component, Prop, Event, EventEmitter, Method, State, Element, h } from '@stencil/core';
import { Color, Size } from '../../interface';

@Component({
  tag: 'lar-onoff',
  styleUrl: 'onoff.scss',
  shadow: true
})
export class LarvaOnOffNode {
  @Element() el!: HTMLElement;

  /////// LarvaNode base properties
  /**
   * Component main icon
   */
  @Prop({ mutable: true }) icon?: string = 'security';
  /**
   * The color to use from your application's color palette.
   * Detrouble options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop({ mutable: true }) color?: Color = 'primary';
  /**
   * The color to use from your application's color palette for Components modal window.
   */
  @Prop({ mutable: true }) colorModal?: Color;
  /**
   * The color to use from your application's color palette for inputs
   */
  @Prop({ mutable: true }) colorInputs?: Color;
  /**
   * The color to use from your application's color palette for indication icon
   */
  @Prop() colorIconSmall?: Color;
  /**
   * Disable quck actions
   */
  @Prop() disableQuickActions: boolean = false;
  /**
   * Hide node titles
   */
  @Prop() hideTitles?: boolean;
  /**
   * Component superscript title
   */
  @Prop() supTitle?: string;
  /**
   * Component subtitle
   */
  @Prop() subTitle?: string;
  /**
   * Is logging for this component enabled (lar-log subcomponent loaded)
   */
  @Prop() log: boolean = false;
  /**
   * Component main title
   */
  @Prop() mainTitle!: string;
  /**
   * Node size
   */
  @Prop() nodeSize?: Size = 'default';
  /**
   * @see {@link ../readme.md} chapter "Components input and output" for further information.
   */
  @Event() output!: EventEmitter;
  /**
   * @see {@link ../readme.md} chapter "Sub-Components requests and responses" for further information.
   */
  @Event() request!: EventEmitter;
  /////// LarvaNode base properties and events - end

  @State() checked: boolean = false;
  @State() loading: boolean = true;
  private node!: HTMLLarNodeElement;

  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node') as HTMLLarNodeElement;
    this.output.emit();
  }
  /**
   * Larva error input
   */
  @Method()
  async error(data: any) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
    // revert last switch back if error response
    this.checked = !this.checked;
  }
  /**
   * Larva input message
   */
  @Method()
  async input(data: any) {
    this.loading = false;
    this.checked = Boolean(data);
  }

  handleChange(checked: boolean) {
    if (this.checked === checked) {
      return;
    }
    this.checked = !!checked;
    this.loading = true;
    this.output.emit(!!this.checked);
  }

  render() {
    let value = ' ';
    if (!this.loading) {
      value = this.checked ? 'onoff.on' : 'onoff.off';
    }
    const componentProps = {
      onButtonclick: () => this.handleChange(!this.checked),
      value: this.checked ? 'onoff.on' : 'onoff.off',
      disabled: this.loading,
      color: this.colorInputs || this.color
    };
    return [
      <lar-node
        value={value}
        hideTitles={this.hideTitles}
        icon={this.icon}
        color={this.color}
        supTitle={this.supTitle}
        mainTitle={this.mainTitle}
        subTitle={this.subTitle}
        colorModal={this.colorModal}
        colorInputs={this.colorInputs}
        colorIconSmall={this.colorIconSmall}
        loading={this.loading}
        log={this.log}
        nodeSize={this.nodeSize}
        component="lar-onoff-content"
        componentProps={componentProps}
      >
        {this.disableQuickActions === false &&
          <lar-toggle
            slot="titles"
            onLarchange={ev => this.handleChange(ev.detail.checked)}
            checked={this.checked}
            color={this.colorInputs||this.color}
          />
        }
        <slot />
      </lar-node>
    ];
  }
}
